import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="bg-bluegray text-white py-8 mt-16">
            {/*
        Outer wrapper to constrain content width
        (like a container). Adjust max-w to your preference.
      */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Top row: columns with site links */}
                <div className="flex flex-wrap -mx-4">
                    {/* Column 1 */}
                    <div className="w-full sm:w-1/2 px-4 mb-8">
                        <h2 className="font-semibold mb-3">About Us</h2>
                        <ul className="space-y-1">
                            <li>
                                <Link to="/the-mission" className="hover:text-gray-300">
                                    The Mission
                                </Link>
                            </li>
                            <li>
                                <Link to="the-team" className="hover:text-gray-300">
                                    The Team
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Column 2 */}
                    <div className="w-full sm:w-1/2 px-4 mb-8">
                        <h2 className="font-semibold mb-3">Support</h2>
                        <ul className="space-y-1">
                            <li>
                                <Link to="/contact-us" className="hover:text-gray-300">
                                    Contact Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/faq" className="hover:text-gray-300">
                                    FAQs
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Sub-Footer: legal and social links */}
                <div className="border-t border-gray-600 pt-4 mt-4 flex flex-col sm:flex-row justify-between items-center">
                    <div className="text-sm text-gray-400">
                        &copy; {new Date().getFullYear()} Career Mission. All rights reserved.
                    </div>
                    <div className="flex space-x-4 mt-2 sm:mt-0">
                        <Link to="/privacy-policy" className="text-gray-400 hover:text-gray-200 text-sm">
                            Privacy Policy
                        </Link>
                        {/* New Link Added Here */}
                        <Link to="/cookie-policy" className="text-gray-400 hover:text-gray-200 text-sm">
                            Cookie Policy
                        </Link>
                        <Link to="/terms-of-service" className="text-gray-400 hover:text-gray-200 text-sm">
                            Terms of Service
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
